import React from "react";

export function PageHeader({ title, subtitle, action }) {
    return (
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
            <div>
                <h1 className="font-serif text-2xl font-bold tracking-tight md:text-3xl">{title}</h1>
                {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
            </div>
            {action}
        </div>
    );
}

export function StatCard({ label, value, icon: Icon, accent }) {
    return (
        <div className="rounded-2xl border border-border/70 bg-card p-5">
            <div className="flex items-center justify-between">
                <p className="text-sm text-muted-foreground">{label}</p>
                {Icon && <Icon className="h-4 w-4 text-muted-foreground" />}
            </div>
            <p className={`mt-2 font-serif text-2xl font-bold ${accent ? "text-accent" : ""}`}>{value}</p>
        </div>
    );
}

export function EmptyState({ icon: Icon, title, hint, action }) {
    return (
        <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-border py-16 text-center" data-testid="empty-state">
            {Icon && <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-secondary text-muted-foreground"><Icon className="h-6 w-6" /></div>}
            <p className="font-medium">{title}</p>
            {hint && <p className="mt-1 max-w-sm text-sm text-muted-foreground">{hint}</p>}
            {action && <div className="mt-4">{action}</div>}
        </div>
    );
}
